export default __webpack_public_path__ + "static/media/No.4-0.d4052447.jpg";